import Button from "../../Button";
import React, { useEffect, useState } from "react";
import constants from "../../../constants";
import MockTestLibraryHooks from "../../../Hooks/Mock/Student/MockTestLibraryHooks";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";
import "../../../Sass/Layout/MockTestPage/Student/TechnologySpecificLibrary.scss";
import Tooltip from "../../CommonComponents/Tooltip";
const base64ImageRegex =
  /^data:image\/(png|jpeg|jpg|gif|webp);base64,[A-Za-z0-9+/=]+$/;

const isDirectUrl = (value) =>
  typeof value === "string" && /^(https?:)?\/\//i.test(value);

const getImageKey = (test) => {
  const imageKey = test?.image || test?.thumbnail;

  if (
    !imageKey ||
    imageKey === "null" ||
    imageKey === "undefined" ||
    typeof imageKey !== "string"
  ) {
    return null;
  }

  return imageKey;
};

const TechnologyIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#technology-card-icon)">
      <path
        d="M6.0013 0.666626V2.66663M10.0013 0.666626V2.66663M6.0013 13.3333V15.3333M10.0013 13.3333V15.3333M13.3346 5.99996H15.3346M13.3346 9.33329H15.3346M0.667969 5.99996H2.66797M0.667969 9.33329H2.66797M4.0013 2.66663H12.0013C12.7377 2.66663 13.3346 3.26358 13.3346 3.99996V12C13.3346 12.7363 12.7377 13.3333 12.0013 13.3333H4.0013C3.26492 13.3333 2.66797 12.7363 2.66797 12V3.99996C2.66797 3.26358 3.26492 2.66663 4.0013 2.66663ZM6.0013 5.99996H10.0013V9.99996H6.0013V5.99996Z"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="technology-card-icon">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default function TechnologySpecificLibraryCards(Props) {
  const MockTestLibraryHks = MockTestLibraryHooks();
  const { getPreSignedUrl } = useS3FileManagement();
  const test = Props.test;
  const imageKey = getImageKey(test);
  const [signedImageUrl, setSignedImageUrl] = useState(null);
  const [imageLoadFailed, setImageLoadFailed] = useState(false);

  const imageUrl =
    imageKey && (base64ImageRegex.test(imageKey) || isDirectUrl(imageKey))
      ? imageKey
      : signedImageUrl;

  useEffect(() => {
    let isMounted = true;

    const loadImage = async () => {
      setSignedImageUrl(null);
      setImageLoadFailed(false);

      if (!imageKey || base64ImageRegex.test(imageKey) || isDirectUrl(imageKey)) {
        return;
      }

      try {
        const res = await getPreSignedUrl([imageKey], undefined, "", "GET");
        const signedUrl = Array.isArray(res?.url) ? res.url[0] : res?.url;

        if (isMounted) {
          setSignedImageUrl(signedUrl || null);
        }
      } catch (error) {
        console.error("Technology card image signing failed:", error);
        if (isMounted) {
          setImageLoadFailed(true);
        }
      }
    };

    loadImage();

    return () => {
      isMounted = false;
    };
    // getPreSignedUrl is recreated by the hook; imageKey is the intended trigger.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageKey]);

  return (
    <div key={test.id} className="TechnologySpecificLibraryGrid">
      <div className="TechnologySpecificLibraryGridIcon">
        {imageUrl && !imageLoadFailed ? (
          <img
            src={imageUrl}
            alt={test.name || "Test thumbnail"}
            onError={() => setImageLoadFailed(true)}
          />
        ) : (
          <TechnologyIcon />
        )}
      </div>

      <div className="TechnologySpecificLibraryGridContent">
        <div className="TechnologySpecificLibraryGridHeader">
          <div className="TechnologySpecificLibraryGridHeaderTitle">
            {test.name}
          </div>
        </div>

        <div className="TechnologySpecificLibraryGridSubHeader">
          <div className="TechnologySpecificLibraryGridSubHeaderTestTitle">
            {MockTestLibraryHks.getTestType(test)} • {test.questionscount}{" "}
            Questions • {MockTestLibraryHks.getTime(test.testduration)}
          </div>
        </div>
        <Tooltip title={test.description} position="top" maxChars={300} theme="light">
          <div className="TechnologySpecificLibraryGridTestDescription">
            {test.description}
          </div>
        </Tooltip>
        <div className="TechnologySpecificLibraryGridTestTagsDiv">
          {test.tags &&
            test.tags !== "" &&
            test.tags !== null &&
            test.tags !== "null" && (
              <div className="TechnologySpecificLibraryGridTestTags">
                {test.tags}
              </div>
            )}
        </div>
      </div>

      <div className="TechnologySpecificLibraryGridFooter">
        {/* <Button
          size="sm"
          hierarchy={{
            type: "linkColor",
            buttonText: "View Details",
          }}
        /> */}
        <Button
          size="sm"
          onClick={() => MockTestLibraryHks.handleTest(test)}
          icon={{
            type: "trailing",
            icon: test.videoqn === 1 ?(
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.3346 7.44277C18.3346 6.93792 18.3346 6.6855 18.2348 6.56861C18.1482 6.46719 18.0182 6.41337 17.8853 6.42383C17.732 6.43589 17.5535 6.61438 17.1966 6.97136L14.168 9.99996L17.1966 13.0286C17.5535 13.3855 17.732 13.564 17.8853 13.5761C18.0182 13.5866 18.1482 13.5327 18.2348 13.4313C18.3346 13.3144 18.3346 13.062 18.3346 12.5572V7.44277Z"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.66797 8.16663C1.66797 6.7665 1.66797 6.06643 1.94045 5.53165C2.18014 5.06124 2.56259 4.67879 3.03299 4.43911C3.56777 4.16663 4.26784 4.16663 5.66797 4.16663H10.168C11.5681 4.16663 12.2682 4.16663 12.8029 4.43911C13.2734 4.67879 13.6558 5.06124 13.8955 5.53165C14.168 6.06643 14.168 6.76649 14.168 8.16663V11.8333C14.168 13.2334 14.168 13.9335 13.8955 14.4683C13.6558 14.9387 13.2734 15.3211 12.8029 15.5608C12.2682 15.8333 11.5681 15.8333 10.168 15.8333H5.66797C4.26784 15.8333 3.56777 15.8333 3.03299 15.5608C2.56259 15.3211 2.18014 14.9387 1.94045 14.4683C1.66797 13.9335 1.66797 13.2334 1.66797 11.8333V8.16663Z"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ):(
              <svg
                width="20"
                height="20"
                fill="none"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke="white"
                  stroke-width="1.67"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M4.16699 10.0013H15.8337M15.8337 10.0013L10.0003 4.16797M15.8337 10.0013L10.0003 15.8346"
                />
              </svg>
            ),
            nospace: true,
          }}
          hierarchy={{
            type: "primary",
            buttonText:
              test.status === constants.PROGRESS_STATUS.IN_PROGRESS &&
              test.libtype === constants.libTypeIds.CODING_CHALLENGE
                ? "Resume test"
                : "Take test",
          }}
        />
      </div>
    </div>
  );
}
